import { Page } from '@/types'
import { preloadImages, useIsMobile } from '@/utils'
import { TypeGuards } from '@codeleap/types'
import React from 'react'

export function onPreloadImages(pages: Page[]) {
  const isMobile = useIsMobile()

  function getLessonImages(pages: Page[]): string[] {
    const device = isMobile ? 'mobile' : 'web'

    const images = []

    if (pages?.length <= 0) return images

    pages?.forEach(page => {
      const pageImages = {
        background: page?.[device + '_background'],
        foreground: page?.[device + '_foreground']
      }

      if (TypeGuards.isString(pageImages?.background)) {
        images.push(pageImages?.background)
      }

      if (TypeGuards.isString(pageImages?.foreground)) {
        images.push(pageImages?.foreground)
      }
    })

    return images
  }

  const imagesToPreload = React.useMemo(() => {
    return getLessonImages(pages)
  }, [pages?.length])

  React.useEffect(() => {
    // pre-load images
    if (imagesToPreload?.length > 0) {
      preloadImages(imagesToPreload)
    }
  }, [imagesToPreload])
}
